import { render, staticRenderFns } from "./PopularComponent.vue?vue&type=template&id=13cfe934&scoped=true"
import script from "./PopularComponent.vue?vue&type=script&lang=js"
export * from "./PopularComponent.vue?vue&type=script&lang=js"
import style0 from "./PopularComponent.vue?vue&type=style&index=0&id=13cfe934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cfe934",
  null
  
)

export default component.exports